import { PkgShippingMethod } from '@/api/user-package/types/UserPkg'
import { ShippingPrices } from '@/helpers/priceChart'

import { OptionCard } from './OptionCard'

interface Props {
  selectedMethod: string
  onSelectMethod: (methodId: PkgShippingMethod) => void
  packageValue: number
  shippingPrices?: ShippingPrices
}

export const ShippingMethodSelector = ({ selectedMethod, onSelectMethod, shippingPrices }: Props) => {
  const doorToDoorPrice = parseInt(shippingPrices?.doorToDoor?.toString() || '0')
  const pickUpPointPrice = parseInt(shippingPrices?.pickUpPoint?.toString() || '0')
  const isPickUpPointAvailable = pickUpPointPrice > 0

  const shippingMethods = [
    {
      id: PkgShippingMethod.DoorToDoor,
      name: 'משלוח עד הבית',
      description: 'אספקה תוך 14-21 ימי עסקים',
      price: doorToDoorPrice,
    },
    {
      id: PkgShippingMethod.PickUpPoint,
      name: 'משלוח לנקודת חלוקה',
      description: isPickUpPointAvailable
        ? 'אספקה תוך 14-21 ימי עסקים'
        : 'לא ניתן לשלוח לנקודת חלוקה חבילות בעלות משקל פיזי / נפחי הגבוה מ-5 ק״ג',
      price: pickUpPointPrice,
      disabled: !isPickUpPointAvailable,
    },
  ]

  const getPriceDisplay = (price: number, isAvailable: boolean) => {
    if (!isAvailable) return 'לא זמין'
    if (price > 0) return `$${price}`
    return 'טוען...'
  }

  return (
    <div className='space-y-3'>
      {shippingMethods.map(method => (
        <OptionCard
          key={method.id}
          onSelect={() => onSelectMethod(method.id)}
          selected={selectedMethod === method.id}
          title={method.name}
          description={method.description}
          endContent={<p>{getPriceDisplay(method.price, !method.disabled)}</p>}
          disabled={method.disabled}
        />
      ))}
    </div>
  )
}
